module.exports = __webpack_public_path__ + "static/media/background_reserva.e3489ccc.svg";